// extracted by mini-css-extract-plugin
export var backdropBlur = "_jn-0";
export var contentCard = "_jn-5";
export var frame = "_jn-2";
export var image = "_jn-4";
export var imagePane = "_jn-3";
export var modal = "_jn-1";